import styled from 'styled-components'
import { colors } from '@blocket/blocket-ui'

export const FullWidthWrapper = styled.div`
  background-color: ${colors.grey100};
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`

export const ResponsiveColumnWrapper = styled.div`
  max-width: 980px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

export const FullHeightWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${colors.grey100};
`
